import ConfirmationModal, {ConfirmationModalPropsType} from "./ConfirmationModal";
import {graph} from "../../../config/axios-context";
import { DocumentNode } from "@apollo/client";
import useAppContext from "../../../utilities/hooks/useAppContext";
import { useNavigate } from "react-router-dom";

type DeleteConfirmationModalPropType = Partial<Omit<ConfirmationModalPropsType, 'onConfirm'>> & {
    onConfirm: ConfirmationModalPropsType['onConfirm'] | string | DocumentNode,
    onAfterConfirmationExecution?: () => void,
    id?: number,
    name: string,
}

const DeleteConfirmationModal = (props: DeleteConfirmationModalPropType) => {
    const context = useAppContext();
    const navigate = useNavigate();

    const onConfirm = async (e: React.MouseEvent) => {
        const id = props.id || Number(context.searchParams.get(props.name));
        if(typeof props.onConfirm === 'string' || (typeof props.onConfirm === 'object' && 'kind' in props.onConfirm && props.onConfirm.kind === 'Document')) {
            try {
                let onConfirm = props.onConfirm;
                if(/^[a-zA-Z]+$/.test(props.onConfirm.toString())) {
                    onConfirm = `mutation { ${props.onConfirm}(id: ${id}) }`;
                }
                const response = await graph<any, any>({
                    query: onConfirm,
                    variables: {
                        id: id
                    }
                });

                if(response.errors) {
                    throw response.errors;
                }
                
                context.notify('success', 'request.delete.success');
                navigate(-1);
                if(props.onAfterConfirmationExecution) {
                    props.onAfterConfirmationExecution();
                }
            } catch (e: any) {
                navigate(-1);
                context.notify('error', 'request.delete.error', Array.isArray(e) ? e[0].message : e.message);
            }
        } else if(typeof props.onConfirm === 'function') {
            const oc = props.onConfirm(undefined, e) as any;
            if(oc instanceof Promise) {
                await oc;
                if(props.onAfterConfirmationExecution) {
                    props.onAfterConfirmationExecution();
                }
            }
        }
    }

    const onReject = (e: React.MouseEvent) => {
        if(typeof props.onReject === 'function') {
            props.onReject(e);
        } else {
            context.navigate(-1);
        }
    }

    return <ConfirmationModal
        name={props.name}
        text={props.text || 'button.delete'}
        title={props.title}
        onConfirm={onConfirm}
        onReject={onReject}
        confirmationText={props.confirmationText}
        rejectText={props.rejectText}
    />
}

export default DeleteConfirmationModal;
